import adminImage from "../../../assets/images/me.jpg";
import useUserProfile from "../../../customHooks/useUserProfile";
import Support from "../../partials/application-portal/Supports";

function SupportPage() {
  const [userProfile] = useUserProfile();

  return (
    <div className="">
      <Support
        title={"BI SupportPage"}
        description={"Welcome to our support center."}
        subtitle={"Glad to see you again."}
        userProfile={{
          name: userProfile.name,
          imageUrl: userProfile.imageUrl,
        }}
        metrics={[
          {
            adminImage: adminImage,
            label: "Mentor's Profile",
            name: "Simon K. Bankole",
            role: "Project Lead - Bi Erp",
          },
          {
            label: "Career Goal",
            goal: "pilot",
          },
        ]}
        table={{
          columns: [
            { Header: "Name", accessor: "name" },
            { Header: "Mode", accessor: "mode" },
          ],
          data: [{ name: "BI Enterprise", mode: "Cashier" }],
        }}
      />
    </div>
  );
}

export default SupportPage;
